import * as Yup from 'yup';

import {
  UPPERCASE_REG_EX,
  NUMERIC_REG_EX,
  EMAIL_REG_EX,
  LOWERCASE_REG_EX,
  SPECIAL_CHARACTER_REG_EX,
} from '../utils/regex';

export const addNewUserByOrgInitialValues = (isDepartmentOn = false) => {
  let initialValues = {
    firstName: '',
    surname: '',
    email: '',
    password: '',
    confirmPassword: '',
  };

  if (isDepartmentOn) {
    initialValues = {
      ...initialValues,
      departmentId: '',
    };
  }
  return initialValues;
};

export const assignDepartmentValues = (department) => {
  return {
    departmentId: department ? department.id : null,
  };
};

export const assignDepartmentValidationSchema = Yup.object().shape({
  departmentId: Yup.number().nullable(),
});

export const addNewUserByOrgValidationSchema = (t, isDepartmentOn = false) => {
  let validationObj = {
    firstName: Yup.string().required(t('formulary.validation.first_name_required')),
    surname: Yup.string().required(t('formulary.validation.surname_required')),

    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(EMAIL_REG_EX, t('formulary.validation.please_enter_the_valid_format')),
    password: Yup.string()
      .min(8, 'LENGTH_ERROR')
      .required('LENGTH_ERROR')
      .matches(LOWERCASE_REG_EX, 'LOWERCASE_ERROR')
      .matches(UPPERCASE_REG_EX, 'UPPERCASE_ERROR')
      .matches(NUMERIC_REG_EX, 'NUMERIC_ERROR')
      .matches(SPECIAL_CHARACTER_REG_EX, 'SPECIAL_CHARACTER_ERROR'),
    confirmPassword: Yup.string()
      .required(t('formulary.validation.confirm_password_required'))
      .oneOf([Yup.ref('password'), null], t('formulary.validation.doesnt_match_the_new_password')),
  };

  if (isDepartmentOn) {
    validationObj = {
      ...validationObj,
      departmentId: Yup.number().nullable().optional(),
    };
  }

  return Yup.object().shape(validationObj);
};
